import React, { useState } from 'react';
import Loading from '../components/Loading';
import { getNumerologyReading, isGeminiReady } from '../services/geminiService';
import { calculateLifePathNumber } from '../data/astroData';
import { useLanguage } from '../context/LanguageContext';

export default function Numerology() {
  const [form, setForm] = useState({ name: '', dob: '' });
  const [lifePathNumber, setLifePathNumber] = useState(null);
  const [reading, setReading] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { language, t } = useLanguage();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.dob) {
      setError(t('enterNameDob'));
      return;
    }
    if (!isGeminiReady()) {
      setError(t('apiKeyError'));
      return;
    }

    const lpn = calculateLifePathNumber(form.dob);
    setLifePathNumber(lpn);

    setLoading(true);
    setError('');
    setReading('');
    try {
      const result = await getNumerologyReading(form.name, form.dob, language);
      setReading(result);
    } catch (err) {
      setError(err.message || 'Failed to generate numerology reading.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="container">
        <div className="page-header">
          <h2>{t('numerologyTitle')}</h2>
          <p>{t('numerologyDesc')}</p>
        </div>

        <div className="card" style={{ maxWidth: '500px', margin: '0 auto 2rem' }}>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>{t('fullName')}</label>
              <input type="text" name="name" value={form.name} onChange={handleChange} placeholder={t('enterFullName')} required />
            </div>
            <div className="form-group">
              <label>{t('dateOfBirth')}</label>
              <input type="date" name="dob" value={form.dob} onChange={handleChange} required />
            </div>
            <button className="btn btn-primary" type="submit" disabled={loading} style={{ width: '100%' }}>
              {loading ? t('calculating') : t('calculateNumerology')}
            </button>
          </form>
        </div>

        {loading && <Loading message={t('loadingNumerology')} />}
        {error && <div className="error-message">{error}</div>}

        {lifePathNumber !== null && !loading && (
          <div className="result-container">
            <div className="card numerology-result" style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
              <p style={{ color: 'var(--text-secondary)', marginBottom: '0.5rem' }}>{t('lifePathNumber')}</p>
              <div className="numerology-number">{lifePathNumber}</div>
              <p style={{ color: 'var(--text-muted)', marginTop: '0.5rem', fontSize: '0.9rem' }}>
                {lifePathNumber === 11 || lifePathNumber === 22 || lifePathNumber === 33
                  ? t('masterNumber')
                  : t('uniqueFrequency')}
              </p>
            </div>
          </div>
        )}

        {reading && (
          <div className="result-container">
            <div className="result-card">
              <h3>{t('numerologyResult', { name: form.name })}</h3>
              <div className="content">{reading}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
